import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;

import { computed, observable, runInAction, makeObservable, action } from "mobx";
import { persist } from "mobx-persist";
import * as yup from "yup";

var _SCHEMA = yup.object({
  email: yup.string().email("Please enter a valid email").required("Please enter a valid email"),
  password: yup.string().required("Please enter a value")
});

var LoginModal = (_dec = persist("object"), _dec2 = persist("object"), (_class = /*#__PURE__*/function () {
  function LoginModal() {
    _classCallCheck(this, LoginModal);

    _initializerDefineProperty(this, "_email", _descriptor, this);

    _initializerDefineProperty(this, "_password", _descriptor2, this);

    _initializerDefineProperty(this, "_socialUID", _descriptor3, this);

    _initializerDefineProperty(this, "_showLoginModal", _descriptor4, this);

    _initializerDefineProperty(this, "_showLinkModal", _descriptor5, this);

    _initializerDefineProperty(this, "_allowDismiss", _descriptor6, this);

    _initializerDefineProperty(this, "_isLoginEnforced", _descriptor7, this);

    _initializerDefineProperty(this, "_socialMediaType", _descriptor8, this);

    _initializerDefineProperty(this, "_disableAutoLogin", _descriptor9, this);

    _initializerDefineProperty(this, "_promptBiometricAuth", _descriptor10, this);

    _initializerDefineProperty(this, "_socialProfile", _descriptor11, this);

    _initializerDefineProperty(this, "_userSelectedProfilePicture", _descriptor12, this);

    _initializerDefineProperty(this, "_profilePictureLoadingState", _descriptor13, this);

    makeObservable(this);
  }

  _createClass(LoginModal, [{
    key: "reset",
    value: function reset() {
      this._email = "";
      this._password = "";
      this._socialUID = "";
      this._showLoginModal = false;
      this._showLinkModal = false;
      this._allowDismiss = true;
      this._isLoginEnforced = false;
      this.promptBiometricAuth = false;
    }
  }, {
    key: "clearInvalidCredentials",
    value: function clearInvalidCredentials() {
      this._email = "";
      this._password = "";
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "showLoginModal",
    get: function get() {
      return this._showLoginModal;
    },
    set: function set(val) {
      var _this = this;

      runInAction(function () {
        _this._showLoginModal = val;
      });
    }
  }, {
    key: "socialProfile",
    get: function get() {
      return this._socialProfile;
    },
    set: function set(val) {
      var _this2 = this;

      runInAction(function () {
        _this2._socialProfile = val;
      });
    }
  }, {
    key: "userSelectedProfilePicture",
    get: function get() {
      return this._userSelectedProfilePicture;
    },
    set: function set(val) {
      var _this3 = this;

      runInAction(function () {
        _this3._userSelectedProfilePicture = val;
      });
    }
  }, {
    key: "profilePictureLoadingState",
    get: function get() {
      return this._profilePictureLoadingState;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        _this4._profilePictureLoadingState = val;
      });
    }
  }, {
    key: "allowDismiss",
    get: function get() {
      return this._allowDismiss;
    },
    set: function set(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._allowDismiss = val;
      });
    }
  }, {
    key: "email",
    get: function get() {
      return this._email;
    },
    set: function set(_email) {
      var _this6 = this;

      runInAction(function () {
        _this6._email = _email;
      });
    }
  }, {
    key: "socialMediaType",
    get: function get() {
      return this._socialMediaType;
    },
    set: function set(_socialMediaType) {
      var _this7 = this;

      runInAction(function () {
        _this7._socialMediaType = _socialMediaType;
      });
    }
  }, {
    key: "password",
    get: function get() {
      return this._password;
    },
    set: function set(_password) {
      var _this8 = this;

      runInAction(function () {
        _this8._password = _password;
      });
    }
  }, {
    key: "socialUID",
    get: function get() {
      return this._socialUID;
    },
    set: function set(_socialUID) {
      var _this9 = this;

      runInAction(function () {
        _this9._socialUID = _socialUID;
      });
    }
  }, {
    key: "showLinkModal",
    get: function get() {
      return this._showLinkModal;
    },
    set: function set(val) {
      var _this10 = this;

      runInAction(function () {
        _this10._showLinkModal = val;
      });
    }
  }, {
    key: "isLoginEnforced",
    get: function get() {
      return this._isLoginEnforced;
    },
    set: function set(val) {
      var _this11 = this;

      runInAction(function () {
        _this11._isLoginEnforced = val;
      });
    }
  }, {
    key: "disableAutoLogin",
    get: function get() {
      return this._disableAutoLogin;
    },
    set: function set(val) {
      var _this12 = this;

      runInAction(function () {
        _this12._disableAutoLogin = val;
      });
    }
  }, {
    key: "promptBiometricAuth",
    get: function get() {
      return this._promptBiometricAuth;
    },
    set: function set(_promptBiometricAuth) {
      var _this13 = this;

      runInAction(function () {
        _this13._promptBiometricAuth = _promptBiometricAuth;
      });
    }
  }]);

  return LoginModal;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_password", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_socialUID", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_showLoginModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_showLinkModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_allowDismiss", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isLoginEnforced", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_socialMediaType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_disableAutoLogin", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_promptBiometricAuth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_socialProfile", [observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_userSelectedProfilePicture", [_dec2, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_profilePictureLoadingState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showLoginModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showLoginModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "socialProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "socialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userSelectedProfilePicture", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userSelectedProfilePicture"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "profilePictureLoadingState", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "profilePictureLoadingState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allowDismiss", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allowDismiss"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "email", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "email"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "socialMediaType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "socialMediaType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "password", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "password"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "socialUID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "socialUID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showLinkModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showLinkModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoginEnforced", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoginEnforced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableAutoLogin", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableAutoLogin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearInvalidCredentials", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearInvalidCredentials"), _class.prototype)), _class));
export { LoginModal as default };